export const translations = {
  pt: {
    // Layout and Navigation
    siteTitle: "FAEI",
    sitePosition: "Força Aliada de Evangelização Internacional",
    siteDescription: "O FAEI é uma Agência Missionária composta por Jovens, que foi fundado em 10 de Maio de 2005.",
    menuHome: "Início",
    menuAbout: "Sobre o FAEI",
    menuEnlist: "Aliste-se",
    menuShare: "Compartilhe",
    menuDonateTime: "Doando tempo, fazendo acontecer",
    menuGallery: "Galeria",
    menuCollaborators: "Colaboradores",
    menuUniforms: "Uniformes do FAEI",
    menuAme: "AME",
    menuApoioPm: "Apoio ao Policial Militar",
    menuBlog: "Blog",
    titleBackHome: "Voltar para a home",
    titleChangeTheme: "Mudar o tema",
    titleChangeView: "Mudar visualização",
    titleGoTop: "Ir para o Topo",

    // 404 page
    notfoundTitle: "404: Não Encontrado",
    notfoundText: "Você acabou de acessar uma rota que não existe... a tristeza.",

    // Index page (Homepage)
    homeTopSubtitle: "Força Aliada de Evangelização Internacional",
    homeTopDescription: "Uma agência missionária e de evangelização urbana, que agrega cristãos de várias denominações que possuem no seu coração o desejo de mudar o mundo pelo poder de Deus.",
    homeTopSaibaMais: "Saiba mais",
    homeKnowMoreTitle: "Quer fazer parte desta Força?",
    homeKnowMoreText: "Se você é jovem cristão com idade acima de 14 anos, solteiro (a) ou se você já é casado (a), e está em comunhão com Cristo e não está conformado com este mundo. Sente arder no teu coração o desejo de mudança? Então o seu lugar é no FAEI! Aliste-se.",
    homeKnowMoreAliste: "Aliste-se",
    homeDonateTimeTitle: "Doando tempo, fazendo acontecer!",
    homeDonateTimeText: "Doe seu tempo investindo nesta obra. Se você é servo(a) de Deus e tem o desejo de ser um missionário(a) urbano, você pode doar o seu tempo aliando-se ao FAEI para executar as missões evangelísticas urbanas. Ou, pode doar o seu tempo como professor de música, como professor de alfabetização ou fazendo apoio psicólogo. Caso você não tenha como investir o seu tempo nas operações de evangelização e apoio, você ainda pode ser patrocinador desta obra.",
    homeDonateTimeSaibaMais: "Saiba Mais!",

    // Sobre page
    sobreSeoTitle: "Sobre o FAEI",
    sobreTitle: "FAEI",
    sobreDescription: "Força Aliada de Evangelização Internacional, uma Obra Missionária Urbana!",
    sobreList1: "Ensino da Palavra de Deus",
    sobreList2: "Apoio Psicológico",
    sobreList3: "Formação Profissional",
    sobreList4: "Mudando Vidas nas Periferias",
    sobreList5: "Cursos teológicos",
    sobreList6: "Aulas de Música",
    sobreList7: "Curso de Alfabetização",
    sobreP1: "O FAEI é uma instituição não governamental e sem fins lucrativos, que faz um trabalho missionário urbano, ensinando a Palavra de Deus, oferecendo apoio psicológico e formação profissional para jovens em comunidades periféricas. Esta obra missionária resgata jovens da marginalidade e promovem perspectivas de futuro. O FAEI atua em comunidades carentes, realizando evangelismo e conscientização, especialmente em áreas com altos índices de furtos e violência. Há 18 anos comprometidos com o IDE do Senhor Jesus Cristo e na transformação de uma sociedade mais justa e mais cheia da presença de Deus, que é a consequência direta da evangelização.",
    sobreP2: "O FAEI apoia missionários em activities externas, apoia e desenvolve missões evangelísticas urbanas através do fornecimento de bíblias e literatura cristã, apoio emergencial, discipulado, capacitação de líderes, aconselhamento pós-trauma, apoios psicólogicos, terapias, defesa de direitos e outros tipos de apoio sociais.",
    sobreQuote: "\"E lhes ordenou: Enquanto estiverdes indo pelo mundo inteiro proclamai o Evangelho a toda criatura.\"",
    sobreQuoteRef: "(Marcos 16:15)",

    // Alistamento page
    alistamentoSeoTitle: "Alistamento",
    alistamentoHeader: "Quero fazer parte desta força!",
    alistamentoP1: "Se você é jovem cristão com idade acima de 14 anos, solteiro (a) ou se você já é casado (a), é cristão, e está em comunhão com Cristo e não está conformado com este mundo, como diz a Palavra:",
    alistamentoQuote: "\"E não sede conformados com este mundo, mas sede transformados pela renovação do vosso entendimento, para que experimenteis qual seja a boa, agradável, e perfeita vontade de Deus.\"",
    alistamentoQuoteRef: "Romanos 12.2",
    alistamentoP2: "Sente arder no teu coração o desejo de mudança? Então o seu lugar é no FAEI! Aliste-se.",
    alistamentoImgAlt: "Alistamento do FAEI",
    alistamentoShareTitle: "Convite para o FAEI",
    alistamentoShareText: "Se você é jovem cristão com idade acima de 14 anos, solteiro (a), e não está conformado com este mundo, como diz a Palavra: E não sede conformados com este mundo, mas sede transformados pela renovação do vosso entendimento, para que experimenteis qual seja a boa, agradável, e perfeita vontade de Deus. Romanos 12.2 Sente arder no teu coração o desejo de mudança? Então o seu lugar é no FAEI!",

    // AME page
    ameSeoTitle: "FAEI - AME",
    ameTitle: "AME",
    ameDescription: "Aliadas das Missões Evangelísticas",
    ameP1: "O AME representa a parceria entre diversas denominações evangélicas, que se unem em prol das Missões Evangelísticas Urbanas. Essas missões incluem atividades como evangelismo conjunto, cultos ao ar livre e operações de impacto, cursos teológicos, palestras, cursos de formação de líderes e obreiros.",
    ameP2: "Nossa missão transcende os limites individuais, pois nosso principal objetivo é unir esforços para o crescimento do Reino de Deus. Acreditamos que, ao nos unirmos, podemos alcançar resultados mais eficazes, impactando vidas e comunidades de maneira mais profunda e significativa. Juntos, somos mais fortes e eficazes para compartilhar a mensagem de amor e esperança que o Evangelho traz, cumprindo assim a missão do \"IDE\" e alcançando mais almas para a Glória do nosso Senhor Jesus Cristo. Temos o grande prazer de viver aqui na Terra o que em breve viveremos no Reino celestial, a harmonia de um único corpo, tendo Cristo como cabeça.",
    ameQuote: "\"A graça do Senhor Jesus Cristo, o amor de Deus e a comunhão do Espírito Santo estejam com todos vós!\"",
    ameQuoteRef: "(2 Coríntios 13.14)",
    amePartnerTitle: "Igrejas parceiras neste objetivo:",
    amePartnerLogoAlt: "Logo Iemir",
    amePartnerName: "Igreja Evangélica Missão Internacional Redenção",

    // Apoio Policial page
    pmSeoTitle: "Apoio ao Policial Militar",
    pmTitle: "Apoio ao Policial Militar",
    pmDescription: "O FAEI executa, por meio de seus pastores, o evangelismo, aconselhamento e apoio espiritual aos Policiais Militares que atuam nas regiões das nossas unidades.",
    pmP1: "Durante a pandemia, distribuiu máscaras em diversas ocasiões aos policiais militares, além de bíblias e panfletos com mensagens de paz e esperança!",
    pmP2: "O FAEI também trabalha incansavelmente em suas reuniões internas com os jovens e adolescentes das comunidades, apresentando nossa Polícia Militar como aliada dos cidadãos, com o objetivo de desmistificar a ideia de que nossos policiais militares são inimigos da comunidade.",
    pmP3: "Este trabalho desafiador requer unção, direção e graça. O FAEI cumpre sua missão evangelística com coragem e determinação, colhendo os frutos para a glória de Deus Pai!",
    pmQuote: "\"Pois ela serve a Deus para o teu bem. Mas, se fizerdes o mal, teme, pois não é sem razão que traz a espada. É serva de Deus, agente da justiça para punir quem pratica o mal.\"",
    pmQuoteRef: "(Romanos 13.4)",
    pmSloganTitle: "Brado dos evangelistas do FAEI:",
    pmSloganLine1: "PELO SENHOR!",
    pmSloganLine2: "PELA REDENÇÃO!",
    pmSloganLine3: "FAEI!",
    pmSupportOrg: "Nós apoiamos a organização:",
    pmSupportLogoAlt: "Logo PM de Cristo",
    pmSupportName: "PMs de Cristo",

    // Colaboradores page
    colaboradoresSeoTitle: "Colaboradores do FAEI",
    colaboradoresHeader: "Colaboradores voluntários do FAEI",
    colaboradoresDescription: "Clique nos brasões abaixo e veja os voluntários:",
    colaboradoresAdmin: "Administração do FAEI",
    colaboradoresGroups: "Grupamentos de Evangelismo",
    colaboradoresAlphaOpen: "Atenção! O grupamento ALFA está com inscrições abertas para jovens evangélicos solteiros (as).",
    colaboradoresAlphaStep: "A inscrição é o primeiro passo. Após o deferimento da inscrição, o futuro candidato será avaliado para a concretização do alistamento.",

    // Compartilhe page
    compartilheSeoTitle: "Compartilhe",
    compartilheHeader: "Informações compartilháveis",
    compartilheConvite: "Convite especial",
    compartilhePatrocinador: "Seja patrocinador de uma Obra Missionária Urbana!",
    compartilheFolheto: "Folheto de evangelismo",
    compartilheUniformes: "Uniformes de Evangelização",
    compartilheCamisetaPreta: "Camiseta Preta do FAEI",
    compartilheCamisetaBranca: "Camiseta Branca do FAEI",

    // Doando Tempo page
    doandoSeoTitle: "Doando tempo, fazendo acontecer!",
    doandoTitle: "Doando tempo, fazendo acontecer!",
    doandoP1: "Doe seu tempo investindo nesta obra. Se você é servo(a) de Deus e tem o desejo de ser um missionário(a) urbano, você pode doar o seu tempo aliando-se ao FAEI para executar as missões evangelísticas urbanas. Ou, pode doar o seu tempo como professor de música, como professor de alfabetização ou fazendo apoio psicólogo.",
    doandoP2: "Caso você não tenha como investir o seu tempo nas operações de evangelização e apoio, você ainda pode ser patrocinador desta obra, fazendo uma doação através do meio que for possível a você, seja por Pix ou Cartão de Crédito através do PayPal.",

    // Galeria page
    galeriaSeoTitle: "Galeria de mídias",
    galeriaTitle: "GALERIA",
    galeriaDescription: "Acompanhe e conheça algumas atividades realizadas pelo FAEI",
    galeriaAriaLabel: "Seleção de Galeria Imagens e videos",

    // Uniformes page
    uniformesSeoTitle: "Compartilhe",
    uniformesTitle: "Uniformes de Evangelização do FAEI",
    uniformesCamisetaPreta: "Camiseta Preta",
    uniformesCamisetaBranca: "Camiseta Branca",

    // Form Component
    formRequiredError: "Este campo é obrigatório",
    formEmailError: "E-mail inválido",
    formSearchCepError: "Erro ao procurar CEP",
    formFullName: "Nome completo",
    formBirthDate: "Data de nascimento",
    formEmail: "E-mail",
    formPhone: "Telefone",
    formZipCode: "CEP",
    formAddress: "Endereço",
    formNumber: "N",
    formNeighborhood: "Bairro",
    formCity: "Cidade",
    formState: "UF",
    formChurch: "Nome da Igreja",
    formBaptismDate: "Data de batismo",
    formEducation: "Escolaridade",
    formEducationFundamentalIncomplete: "Fundamental Incompleto",
    formEducationFundamentalComplete: "Fundamental Completo",
    formEducationMedioIncomplete: "Médio Incompleto",
    formEducationMedioComplete: "Médio Completo",
    formEducationSuperiorIncomplete: "Superior Incompleto",
    formEducationSuperiorComplete: "Superior Completo",
    formEducationMestrado: "Mestrado",
    formEducationDoutorado: "Doutorado",
    formProfession: "Profissão",
    formDoYouWork: "Você está atualmente empregado?",
    formDoYouWorkYes: "Sim",
    formDoYouWorkNo: "Não",
    formWorkplace: "Nome da Empresa",
    formStart: "Horário de início",
    formEnd: "Horário de termino",
    formAboutYou: "Fale sobre você",
    formSubmitButton: "Alistar-se",
    formSuccessMessage: "Alistamento realizado!",
    formErrorMessage: "Erro ao fazer Alistamento!.",

    // Donate Component
    donateCnpjKey: "Chave CNPJ",

    // Collaborators Dynamic Roles
    "Diretor geral": "Diretor geral",
    "Diretor de operações": "Diretor de operações",
    "Secretaria Geral": "Secretaria Geral",
    "Supervisora de Grupamentos": "Supervisora de Grupamentos",
    "Suprimentos": "Suprimentos",
    "Desenvolvimento Web": "Desenvolvimento Web",
    "Criação e design": "Criação e design",
    "Líder": "Líder",
    "SGA - Semeadora do grupamento Alpha": "SGA - Semeadora do grupamento Alpha",
    "SGA - Semeador do grupamento Alpha": "SGA - Semeador do grupamento Alpha",
    "SGO - Semeador do grupamento Ômega": "SGO - Semeador do grupamento Ômega",
    "Diretora": "Diretora",
    "Supervisora": "Supervisora",
    "SGE - Semeadora do grupamento Esther": "SGE - Semeadora do grupamento Esther",
    "Professor de Música": "Professor de Música",
    "SGS - Semeador do grupamento Shalom": "SGS - Semeador do grupamento Shalom",
    "SGS - Semeadora do grupamento Shalom": "SGS - Semeadora do grupamento Shalom",
    "SGMP - Semeadora do grupamento Mensageiros da paz": "SGMP - Semeadora do grupamento Mensageiros da paz",
    "SGMP - Semeador do grupamento Mensageiros da paz": "SGMP - Semeador do grupamento Mensageiros da paz"
  },
  en: {
    // Layout and Navigation
    siteTitle: "FAEI",
    sitePosition: "Allied Force of International Evangelization",
    siteDescription: "FAEI is a Youth Missionary Agency founded on May 10, 2005.",
    menuHome: "Home",
    menuAbout: "About FAEI",
    menuEnlist: "Enlist",
    menuShare: "Share",
    menuDonateTime: "Donating time, making it happen",
    menuGallery: "Gallery",
    menuCollaborators: "Collaborators",
    menuUniforms: "FAEI Uniforms",
    menuAme: "AME",
    menuApoioPm: "Military Police Support",
    menuBlog: "Blog",
    titleBackHome: "Back to home",
    titleChangeTheme: "Change theme",
    titleChangeView: "Change view",
    titleGoTop: "Go to top",

    // 404 page
    notfoundTitle: "404: Not Found",
    notfoundText: "You just hit a route that doesn't exist... the sadness.",

    // Index page (Homepage)
    homeTopSubtitle: "Allied Force of International Evangelization",
    homeTopDescription: "A missionary and urban evangelization agency, which aggregates Christians from various denominations who have in their heart the desire to change the world by the power of God.",
    homeTopSaibaMais: "Learn more",
    homeKnowMoreTitle: "Want to be part of this Force?",
    homeKnowMoreText: "If you are a young Christian over 14 years old, single, or if you are already married, Christian, in communion with Christ and not conformed to this world. Do you feel the desire for change burning in your heart? Then your place is in FAEI! Enlist.",
    homeKnowMoreAliste: "Enlist",
    homeDonateTimeTitle: "Donating time, making it happen!",
    homeDonateTimeText: "Donate your time by investing in this work. If you are a servant of God and desire to be an urban missionary, you can donate your time by joining FAEI to perform urban evangelistic missions. Or, you can donate your time as a music teacher, as a literacy teacher, or by providing psychological support. If you cannot invest your time in evangelization and support operations, you can still sponsor this work.",
    homeDonateTimeSaibaMais: "Learn More!",

    // Sobre page
    sobreSeoTitle: "About FAEI",
    sobreTitle: "FAEI",
    sobreDescription: "Allied Force of International Evangelization, an Urban Missionary Work!",
    sobreList1: "Teaching of the Word of God",
    sobreList2: "Psychological Support",
    sobreList3: "Professional Training",
    sobreList4: "Changing Lives in Peripheral Communities",
    sobreList5: "Theological Courses",
    sobreList6: "Music Classes",
    sobreList7: "Literacy Courses",
    sobreP1: "FAEI is a non-governmental, non-profit institution that performs urban missionary work, teaching the Word of God, offering psychological support, and professional training for young people in peripheral communities. This missionary work rescues young people from marginalization and promotes future perspectives. FAEI operates in underprivileged communities, performing evangelism and awareness, especially in areas with high rates of theft and violence. For 18 years we have been committed to the Great Commission of the Lord Jesus Christ and the transformation of a more just society filled with God's presence, which is the direct consequence of evangelization.",
    sobreP2: "FAEI supports missionaries in external activities, supports and develops urban evangelistic missions through the provision of Bibles and Christian literature, emergency support, discipleship, leadership training, post-trauma counseling, psychological support, therapies, rights advocacy, and other social support types.",
    sobreQuote: "\"And he said unto them, Go ye into all the world, and preach the gospel to every creature.\"",
    sobreQuoteRef: "(Mark 16:15)",

    // Alistamento page
    alistamentoSeoTitle: "Enlistment",
    alistamentoHeader: "I want to be part of this force!",
    alistamentoP1: "If you are a young Christian over 14 years old, single, or if you are already married, Christian, in communion with Christ and not conformed to this world, as the Word says:",
    alistamentoQuote: "\"Do not conform to the pattern of this world, but be transformed by the renewing of your mind. Then you will be able to test and approve what God’s will is—his good, pleasing and perfect will.\"",
    alistamentoQuoteRef: "Romans 12:2",
    alistamentoP2: "Do you feel the desire for change burning in your heart? Then your place is in FAEI! Enlist.",
    alistamentoImgAlt: "FAEI Enlistment",
    alistamentoShareTitle: "Invitation to FAEI",
    alistamentoShareText: "If you are a young Christian over 14 years old, single, and not conformed to this world, as the Word says: Do not conform to the pattern of this world, but be transformed by the renewing of your mind, that you may prove what is that good and acceptable and perfect will of God. Romans 12:2. Do you feel the desire for change burning in your heart? Then your place is in FAEI!",

    // AME page
    ameSeoTitle: "FAEI - AME",
    ameTitle: "AME",
    ameDescription: "Allies of Evangelistic Missions",
    ameP1: "AME represents the partnership between different evangelical denominations that unite in favor of Urban Evangelistic Missions. These missions include activities such as joint evangelism, outdoor services, impact operations, theological courses, lectures, and training courses for leaders and workers.",
    ameP2: "Our mission transcends individual boundaries, as our main objective is to join forces for the growth of the Kingdom of God. We believe that by uniting, we can achieve more effective results, impacting lives and communities in a deeper and more meaningful way. Together, we are stronger and more effective in sharing the message of love and hope that the Gospel brings, fulfilling the mission of the \"GREAT COMMISSION\" and reaching more souls for the Glory of our Lord Jesus Christ. We have the great pleasure of living here on Earth what we will soon live in the heavenly Kingdom, the harmony of a single body, with Christ as the head.",
    ameQuote: "\"The grace of the Lord Jesus Christ, and the love of God, and the communion of the Holy Ghost, be with you all. Amen.\"",
    ameQuoteRef: "(2 Corinthians 13:14)",
    amePartnerTitle: "Partner churches in this objective:",
    amePartnerLogoAlt: "Iemir Logo",
    amePartnerName: "International Redemption Mission Evangelical Church",

    // Apoio Policial page
    pmSeoTitle: "Military Police Support",
    pmTitle: "Military Police Support",
    pmDescription: "FAEI executes, through its pastors, evangelism, counseling, and spiritual support to the Military Police who operate in the areas of our units.",
    pmP1: "During the pandemic, it distributed masks on several occasions to military police officers, as well as Bibles and pamphlets with messages of peace and hope!",
    pmP2: "FAEI also works tirelessly in its internal meetings with the youth and adolescents of the communities, presenting our Military Police as an ally of citizens, with the objective of demystifying the idea that our military police officers are enemies of the community.",
    pmP3: "This challenging work requires anointing, direction, and grace. FAEI fulfills its evangelistic mission with courage and determination, reaping the fruits for the glory of God the Father!",
    pmQuote: "\"For the one in authority is God’s servant for your good. But if you do wrong, be afraid, for rulers do not bear the sword for no reason. They are God’s servants, agents of wrath to bring punishment on the wrongdoer.\"",
    pmQuoteRef: "(Romans 13:4)",
    pmSloganTitle: "Battle cry of FAEI evangelists:",
    pmSloganLine1: "FOR THE LORD!",
    pmSloganLine2: "FOR REDEMPTION!",
    pmSloganLine3: "FAEI!",
    pmSupportOrg: "We support the organization:",
    pmSupportLogoAlt: "PMs de Cristo Logo",
    pmSupportName: "PMs de Cristo",

    // Colaboradores page
    colaboradoresSeoTitle: "FAEI Collaborators",
    colaboradoresHeader: "FAEI Volunteer Collaborators",
    colaboradoresDescription: "Click on the crests below to see the volunteers:",
    colaboradoresAdmin: "FAEI Administration",
    colaboradoresGroups: "Evangelism Groups",
    colaboradoresAlphaOpen: "Attention! The ALPHA group has open registration for young single Christians.",
    colaboradoresAlphaStep: "Registration is the first step. After approval of the registration, the future candidate will be evaluated to complete the enlistment.",

    // Compartilhe page
    compartilheSeoTitle: "Share",
    compartilheHeader: "Shareable information",
    compartilheConvite: "Special Invitation",
    compartilhePatrocinador: "Be a sponsor of an Urban Missionary Work!",
    compartilheFolheto: "Evangelism leaflet",
    compartilheUniformes: "Evangelization Uniforms",
    compartilheCamisetaPreta: "FAEI Black T-Shirt",
    compartilheCamisetaBranca: "FAEI White T-Shirt",

    // Doando Tempo page
    doandoSeoTitle: "Donating time, making it happen!",
    doandoTitle: "Donating time, making it happen!",
    doandoP1: "Donate your time by investing in this work. If you are a servant of God and desire to be an urban missionary, you can donate your time by joining FAEI to perform urban evangelistic missions. Or, you can donate your time as a music teacher, as a literacy teacher, or by providing psychological support.",
    doandoP2: "If you cannot invest your time in evangelization and support operations, you can still sponsor this work by making a donation in any way possible to you, either via Pix or Credit Card through PayPal.",

    // Galeria page
    galeriaSeoTitle: "Media Gallery",
    galeriaTitle: "GALLERY",
    galeriaDescription: "Follow and learn about some activities carried out by FAEI",
    galeriaAriaLabel: "Image and video gallery selection",

    // Uniformes page
    uniformesSeoTitle: "Share",
    uniformesTitle: "FAEI Evangelization Uniforms",
    uniformesCamisetaPreta: "Black T-Shirt",
    uniformesCamisetaBranca: "White T-Shirt",

    // Form Component
    formRequiredError: "This field is required",
    formEmailError: "Invalid email",
    formSearchCepError: "Error searching ZIP code",
    formFullName: "Full name",
    formBirthDate: "Date of birth",
    formEmail: "Email",
    formPhone: "Phone number",
    formZipCode: "ZIP code",
    formAddress: "Address",
    formNumber: "N",
    formNeighborhood: "Neighborhood",
    formCity: "City",
    formState: "State",
    formChurch: "Church Name",
    formBaptismDate: "Baptism date",
    formEducation: "Education",
    formEducationFundamentalIncomplete: "Elementary Incomplete",
    formEducationFundamentalComplete: "Elementary Complete",
    formEducationMedioIncomplete: "High School Incomplete",
    formEducationMedioComplete: "High School Complete",
    formEducationSuperiorIncomplete: "University Incomplete",
    formEducationSuperiorComplete: "University Complete",
    formEducationMestrado: "Master's Degree",
    formEducationDoutorado: "Doctoral Degree",
    formProfession: "Profession",
    formDoYouWork: "Are you currently employed?",
    formDoYouWorkYes: "Yes",
    formDoYouWorkNo: "No",
    formWorkplace: "Company Name",
    formStart: "Start time",
    formEnd: "End time",
    formAboutYou: "About you",
    formSubmitButton: "Enlist",
    formSuccessMessage: "Enlistment completed!",
    formErrorMessage: "Error enlisting!.",

    // Donate Component
    donateCnpjKey: "CNPJ Key",

    // Collaborators Dynamic Roles
    "Diretor geral": "General Director",
    "Diretor de operações": "Operations Director",
    "Secretaria Geral": "General Secretary",
    "Supervisora de Grupamentos": "Groups Supervisor",
    "Suprimentos": "Supplies",
    "Desenvolvimento Web": "Web Development",
    "Criação e design": "Creation and Design",
    "Líder": "Leader",
    "SGA - Semeadora do grupamento Alpha": "SGA - Sower of Alpha group",
    "SGA - Semeador do grupamento Alpha": "SGA - Sower of Alpha group",
    "SGO - Semeador do grupamento Ômega": "SGO - Sower of Omega group",
    "Diretora": "Director",
    "Supervisora": "Supervisor",
    "SGE - Semeadora do grupamento Esther": "SGE - Sower of Esther group",
    "Professor de Música": "Music Teacher",
    "SGS - Semeador do grupamento Shalom": "SGS - Sower of Shalom group",
    "SGS - Semeadora do grupamento Shalom": "SGS - Sower of Shalom group",
    "SGMP - Semeadora do grupamento Mensageiros da paz": "SGMP - Sower of Messengers of Peace group",
    "SGMP - Semeador do grupamento Mensageiros da paz": "SGMP - Sower of Messengers of Peace group"
  }
};
